import { jsx as _jsx } from "react/jsx-runtime";
/** Keep every verification action reachable inside either product's card. */
export function VerificationActions({ className = '', children, ...props }) {
    return _jsx("div", { ...props, className: `oq-verification-actions ${className}`.trim(), children: children });
}
//# sourceMappingURL=VerificationActions.js.map